(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["op-content-protection"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.Shopify && window.Shopify.designMode) return;
    if (document.documentElement.dataset.opContentProtection) return;
    document.documentElement.dataset.opContentProtection = '2';

    const allowed = 'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [data-op-allow-copy]';
    const interactive = allowed + ', a[href], button';
    const strictDescription = '[data-op-protect-text="product"]';
    const asElement = (node) => node && (node.nodeType === 1 ? node : node.parentElement);

    const matchesAncestor = (node, selector) => {
      const element = asElement(node);
      return Boolean(element && element.closest(selector));
    };

    const imageAt = (node) => {
      const element = asElement(node);
      if (!element || matchesAncestor(element, allowed) || !element.closest('#MainContent, .pswp, media-gallery')) return null;
      const media = element.closest('img, picture, .media');
      return media && (media.tagName === 'IMG' ? media : media.querySelector('img'));
    };

    const preventTextTransfer = (event) => {
      if (matchesAncestor(event.target, allowed) || matchesAncestor(document.activeElement, allowed)) return;
      const selection = window.getSelection();
      if (!selection || !selection.rangeCount) return;
      const length = selection.toString().trim().length;
      if (!length) return;
      const sections = document.querySelectorAll('[data-op-protect-text]');
      for (let i = 0; i < selection.rangeCount; i += 1) {
        const range = selection.getRangeAt(i);
        if (matchesAncestor(range.commonAncestorContainer, interactive)) continue;
        for (const section of sections) {
          const protectedSelection = section.matches(strictDescription) || length > 160;
          if (protectedSelection && range.intersectsNode(section)) {
            event.preventDefault();
            return;
          }
        }
      }
    };

    document.addEventListener('contextmenu', (event) => {
      if (imageAt(event.target)) {
        event.preventDefault();
      } else if (matchesAncestor(event.target, strictDescription) && !matchesAncestor(event.target, interactive)) {
        event.preventDefault();
      }
    });

    document.addEventListener('dragstart', (event) => {
      if (imageAt(event.target)) {
        event.preventDefault();
      } else if (!matchesAncestor(event.target, interactive)) {
        preventTextTransfer(event);
      }
    });

    document.addEventListener('copy', preventTextTransfer);
    document.addEventListener('cut', preventTextTransfer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["op-findomestic-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('op-findomestic-guide')) {
    customElements.define('op-findomestic-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.placement !== 'product') return;
        this.productInfo = this.closest('product-info');
        this.handleVariant = (event) => {
          const price = event.detail?.variant?.price;
          this.hidden = !Number.isFinite(price) || price < Number(this.dataset.minimum);
        };
        this.productInfo?.addEventListener('variant:change', this.handleVariant, true);
      }
      disconnectedCallback() {
        this.productInfo?.removeEventListener('variant:change', this.handleVariant, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
